var FacebookAuthProvider = (function () {
    function FacebookAuthProvider() {
    }
    FacebookAuthProvider.TYPE = "oauth2-facebook";
    FacebookAuthProvider.DEFAULT_NAME = "oauth2-facebook";
    return FacebookAuthProvider;
}());
export default FacebookAuthProvider;
//# sourceMappingURL=FacebookAuthProvider.js.map